import httpClient, { httpObjQueryString } from "../config/httpClient";

export const fetchPipelineApi = (filter) => {
  return httpClient.get(`/pipeline?${httpObjQueryString(filter)}`);
};

export const createPipelineApi = (data) => {
  return httpClient.post(`/pipeline/create`, data);
};

export const updatePipelineApi = (data) => {
  return httpClient.put(`/pipeline/${data?.id}`, data);
};

export const getPipelineApi = (id) => {
  return httpClient.get(`/pipeline/${id}`);
};
